import { restApiClient } from '@/datasources';
import { AppointmentsRequestParams, AppointmentsResponse } from '@/types/appointments.types';

export async function getAppointments(params: AppointmentsRequestParams) {
  const { data: appointments } = await restApiClient.get<AppointmentsResponse>('/v2/online/customers/appointments/', {
    ...params,
    limit: 10,
    counting: true,
    onlyId: true,
  });

  return appointments;
}
